import { render } from "./ImplantableDeviceSection.vue?vue&type=template&id=33d64435"
import script from "./ImplantableDeviceSection.ts?vue&type=script&lang=js&external"
export * from "./ImplantableDeviceSection.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__